<template>
  <div class="page-content">
    <div class="page-title">
      <h5>学位论文申请表</h5>
    </div>

    <el-form class="degree-form" :model="applyForm" :rules="rules" :disabled="thesis.applicationStatus == 1" ref="form" label-width="180px">
      <div>
        <div class="title">基本信息</div>
        <div class="bg">
          <!-- 入学年月 -->
          <el-form-item label="入学年月" prop="admissionYear">
            <el-date-picker v-model="applyForm.admissionYear" type="date" placeholder="选择入学年月" size="mini" value-format="yyyy-MM-dd" style="width: 200px"></el-date-picker>
          </el-form-item>

          <!-- 修学年限 -->
          <el-form-item label="修学年限" prop="studyYears">
            <el-input v-model="applyForm.studyYears" size="small" placeholder="请输入修学年限"></el-input>
          </el-form-item>

          <!-- 考试课程平均成绩 -->
          <el-form-item label="考试课程平均成绩" prop="examAvgScore">
            <el-input v-model="applyForm.examAvgScore" size="small" placeholder="请输入考试课程平均成绩"></el-input>
          </el-form-item>

          <!-- 学位类型 -->
          <el-form-item label="学位类型" prop="degreeType">
            <el-select v-model="applyForm.degreeType" size="mini" placeholder="请选择学位类型">
              <el-option label="普通高等教育" value="普通高等教育"></el-option>
              <el-option label="继续教育" value="继续教育"></el-option>
              <el-option label="自学考试" value="自学考试"></el-option>
              <el-option label="国际学生" value="国际学生"></el-option>
            </el-select>
          </el-form-item>
        </div>

        <div class="title">论文信息</div>
        <div class="bg">
          <!-- 论文类型 -->
          <el-form-item label="论文类型" prop="thesisType">
            <el-select v-model="applyForm.thesisType" size="mini" placeholder="请选择论文类型">
              <el-option label="毕业论文" value="毕业论文"></el-option>
              <el-option label="毕业设计" value="毕业设计"></el-option>
              <el-option label="涉密论文" value="涉密论文"></el-option>
              <el-option label="其他" value="其他"></el-option>
            </el-select>
          </el-form-item>

          <!-- 导师姓名 -->
          <el-form-item label="导师姓名" prop="advisorName">
            <el-input v-model="applyForm.advisorName" size="small" placeholder="请输入导师姓名"></el-input>
          </el-form-item>

          <!-- 论文题目 -->
          <el-form-item label="论文题目" prop="thesisTitle">
            <el-input v-model="applyForm.thesisTitle" size="small" placeholder="请输入论文题目"></el-input>
          </el-form-item>

          <!-- 论文关键词 -->
          <el-form-item label="论文关键词" prop="thesisKeywords">
            <el-input v-model="applyForm.thesisKeywords" size="small" placeholder="请输入论文关键词"></el-input>
          </el-form-item>

          <!-- 论文研究方向 -->
          <el-form-item label="论文研究方向" prop="researchDirection">
            <el-input v-model="applyForm.researchDirection" size="small" placeholder="请输入论文研究方向"></el-input>
          </el-form-item>

          <!-- 论文指导种类 -->
          <el-form-item label="论文撰写语种" prop="thesisGuideType">
            <el-select v-model="applyForm.thesisGuideType" size="mini" placeholder="请选择论文指导种类">
              <el-option label="中文" value="中文"></el-option>
              <el-option label="英文" value="英文"></el-option>
              <el-option label="其他" value="其他"></el-option>
            </el-select>
          </el-form-item>

          <!-- 论文选题来源 -->
          <el-form-item label="论文选题来源" prop="thesisTopicSource">
            <el-select v-model="applyForm.thesisTopicSource" size="mini" placeholder="请选择论文选题来源">
              <el-option label="国家重点研发计划项目" value="国家重点研发计划项目"></el-option>
              <el-option label="国家社科规划、基金项目" value="国家社科规划、基金项目"></el-option>
              <el-option label="国家自然科学基金项目" value="国家自然科学基金项目"></el-option>
              <el-option label="中央、国家各部门项目" value="中央、国家各部门项目"></el-option>
              <el-option label="教育部人文、社会科学研究项目" value="教育部人文、社会科学研究项目"></el-option>
              <el-option label="省（自治区、直辖市）项目" value="省（自治区、直辖市）项目"></el-option>
            </el-select>
          </el-form-item>

          <!-- 毕业论文（或设计）成绩 -->
          <el-form-item label="毕业论文（或设计）成绩" prop="thesisOrDesign">
            <el-input v-model="applyForm.thesisOrDesign" size="small" placeholder="请输入毕业论文成绩"></el-input>
          </el-form-item>
        </div>

        <div class="title">其他信息</div>
        <el-row>
          <el-col :span="12">
            <!-- 身份证人像面 -->
            <el-form-item label="身份证人像面" prop="admissionImg">
              <UploadImage  v-model="applyForm.admissionImg" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 身份证国徽面 -->
            <el-form-item label="身份证国徽面" prop="idCardImg">
              <UploadImage  v-model="applyForm.idCardImg" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <!-- 毕业证书 -->
            <el-form-item label="毕业证书" prop="graduationCertImg">
              <UploadImage  v-model="applyForm.graduationCertImg" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 考籍表 -->
            <el-form-item label="考籍表" prop="transcriptImg">
              <UploadImage  v-model="applyForm.transcriptImg" />
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- 提交按钮 -->
      <el-form-item v-if="thesis.applicationStatus != 1">
        <el-button type="primary" @click="submitForm">提交</el-button>
      </el-form-item>
    </el-form>


    <RegisteredPayDialog ref="RegisteredPayDialog" @refresh="getInfo"></RegisteredPayDialog>
    <Notice ref="Notice" title="学位论文须知" />
  </div>
</template>

<script>
export default {
  name: "MySpotCheck",
  components: {
    Notice: () => import("./Notice.vue"),
    RegisteredPayDialog: () => import("./RegisteredPayDialog.vue"),
    UploadImage: () => import("@/components/UploadImage.vue"),
  },
  data() {
    return {
      activeName: "1",
      configs: [],
      info: {},
      defaultThesisBatchId: "",
      config: {},
      thesisProposal: null,
      thesis: null,
      logs: [],
      bm: null,
      curTime: new Date().getTime(),
      nowDate: new Date().getTime(),
      form: {},
      submitToAudit: {
        attPath: "",
        attSize: "",
        atname: "",
        remark: "",
        thesisId: "",
        operType: 1,
      },

      dialogFormVisible: false,



      degree:{},
      statusMap: {
        '0': "待审核",
        '1': "通过",
        '2': "打回修改",
        '-1': "驳回",
      },

      applyForm: {
        admissionYear: "",
        graduationYear: "",
        studyYears: "",
        studentNumber: "",
        examAvgScore: "",
        degreeType: "",
        thesisType: "",
        advisorName: "",
        thesisTitle: "",
        thesisKeywords: "",
        researchDirection: "",
        thesisGuideType: "",
        thesisTopicSource: "",
        thesisOrDesign: "",
        admissionImg: "",
        idCardImg: "",
        graduationCertImg: "",
        transcriptImg: "",
      },
      // applyForm: {
      //   "admissionYear": "2025-12-01",
      //   "studyYears": "2",
      //   "examAvgScore": "81",
      //   "degreeType": "继续教育",
      //   "thesisType": "毕业设计",
      //   "advisorName": "导师姓名",
      //   "thesisTitle": "论文题目",
      //   "thesisKeywords": "论文关键词",
      //   "researchDirection": "论文研究方向",
      //   "thesisGuideType": "英文",
      //   "thesisTopicSource": "国家社科规划、基金项目",
      //   "thesisOrDesign": "88",
      //   "admissionImg": "https://jxjy-att.whxunw.com/sczk_att/upload/editor/20251226/3481E4AA7235436BA1689B0D468EDA56.jpeg",
      //   "idCardImg": "https://jxjy-att.whxunw.com/sczk_att/upload/editor/20251226/284661FD4C484F1DAFD6354CFCD3FD1C.png",
      //   "graduationCertImg": "https://jxjy-att.whxunw.com/sczk_att/upload/editor/20251226/D24223033EFE4F82A138323D3EEB17EC.jpeg",
      //   "transcriptImg": "https://jxjy-att.whxunw.com/sczk_att/upload/editor/20251226/00D24A29D88A49F9A020EE9030DA390E.png"
      // },
      rules: {
        thesisBatchId: [{ required: true, message: "请输入论文批次ID", trigger: "blur" }],
        admissionYear: [{ required: true, message: "请输入有效的入学年月", trigger: "change" }],
        graduationYear: [{ required: true, message: "请输入有效的毕业年月", trigger: "blur" }],
        studyYears: [{ required: true, pattern: /^[0-9]+$/, message: "请输入有效的修学年限", trigger: "blur" }],
        studentNumber: [{ required: true, message: "请输入学历证书编号", trigger: "blur" }],
        examAvgScore: [{ required: true, pattern: /^[0-9]+$/, message: "请输入有效的考试课程平均成绩", trigger: "blur" }],
        degreeType: [{ required: true, message: "请选择学位类型", trigger: "change" }],
        thesisType: [{ required: true, message: "请选择论文类型", trigger: "change" }],
        advisorName: [{ required: true, message: "请输入导师姓名", trigger: "blur" }],
        thesisTitle: [{ required: true, message: "请输入论文题目", trigger: "blur" }],
        thesisKeywords: [{ required: true, message: "请输入论文关键词", trigger: "blur" }],
        researchDirection: [{ required: true, message: "请输入论文研究方向", trigger: "blur" }],
        thesisGuideType: [{ required: true, message: "请选择论文指导种类", trigger: "change" }],
        thesisTopicSource: [{ required: true, message: "请选择论文选题来源", trigger: "change" }],
        thesisOrDesign: [{ required: true, pattern: /^[0-9]+$/, message: "请输入有效的毕业论文成绩", trigger: "blur" }],
        admissionImg: [{ required: true, message: "请上传身份证人像面", trigger: "blur" }],
        idCardImg: [{ required: true, message: "请上传身份证国徽面", trigger: "blur" }],
        graduationCertImg: [{ required: true, message: "请上传毕业证书", trigger: "blur" }],
        transcriptImg: [{ required: true, message: "请上传考籍表", trigger: "blur" }]
      }
    };
  },
  created() {
    // if (this.$route.query.thesisBatchId) this.defaultThesisBatchId = +this.$route.query.thesisBatchId;
    this.getInfo();
  },
  beforeDestroy() {
  },
  methods: {
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log("表单提交", this.applyForm);

          const params = {
            ...this.applyForm,
            thesisBatchId: this.defaultThesisBatchId,
          }
          this.$http
          .post("/student/thesis/degree/application/submit", params)
          .then(res => {
            this.$message.success("上传成功");
            this.$router.replace({
              path: "/main/mySpotCheck",
            });
            // this.getInfo();
          });
        } else {
          console.log("表单验证失败");
          return false;
        }
      });
    },
    openFile(item) {
      const a = document.createElement("a");
      a.href = item.attPath;
      a.target = "_blank";
      a.download =
        "https://view.officeapps.live.com/op/view.aspx?src=" + item.atname;
      a.style.display = "none";
      document.body.append(a);
      a.click();
      document.body.removeChild(a); // 移除
    },
    upload() {
      //模拟点击上传图片
      document.getElementById("fileBtn").click();
    },
    uploadFn() {
      var fileName = this.$refs.file.files[0].name;
      var suffix = fileName.substring(fileName.lastIndexOf(".")).toLowerCase();
      if (
        !(
          suffix == ".doc" ||
          suffix == ".docx" ||
          suffix == ".pdf" ||
          suffix == ".xls" ||
          suffix == ".xlsx"
        )
      ) {
        this.$message.error("文件格式不正确");
        return;
      }
      const formData = new FormData();
      formData.append("file", this.$refs.file.files[0]);
      formData.append("thesisId", this.thesis.id);
      this.UploadChange_other(formData);
    },
    UploadChange_other(formData) {
      var that = this;
      that.$http
        .post("/student/thesis2/uploadAtt2", formData, {
          "Content-Type": "multipart/form-data",
        })
        .then(res => {
          this.$message.success("上传成功");
          this.getInfo();
        });
    },
    getInfo() {
      this.$http
        .post("/student/degree/myThesis", { thesisBatchId: this.defaultThesisBatchId })
        .then(res => {
          this.config = res.config;
          this.configs = res.configs;
          this.info = res;
          if (!this.defaultThesisBatchId) this.defaultThesisBatchId = res.defaultThesisBatchId;

          if (res.thesis.applicationStatus == 1 || res.thesis.applicationStatus == 2) {
            this.getApply()
          }

          this.thesis = res.thesis;
          this.bm = res.bm;
          if (res.thesis.attList) {
            this.thesis.thesisAttUrl = res.thesis.attList.map(e => e.thesisAttUrl)
            this.thesis.thesisDegreeAttSize = res.thesis.attList.map(e => e.thesisAttSize)
            this.thesis.thesisAttFileName = res.thesis.attList.map(e => e.thesisAttFileName)

            // this.thesis.processMaterialsUrl = res.thesis.attList.map(e => e.processMaterialsUrl)
          }
          this.handleClick()
          this.$http
            .get("/student/degree/log/detail/" + res.thesis.thesisDegreeEnrollId)
            .then(res => {
              this.logs = res.logs;
            });
        });
    },
    getApply() {
      this.$http.get("/student/thesis/degree/application/detail", { thesisBatchId: this.defaultThesisBatchId }).then(res => {
        this.applyForm = res
      })
    },
    gonggao(n) {
      const u_id = this.$store.state.user.userId + "3";
      const hasNoticeContent = (content) => {
        if (!content) return false;
        const text = String(content)
          .replace(/<[^>]+>/g, "")
          .replace(/&nbsp;/gi, " ")
          .trim();
        return !!text;
      };
      if (
        hasNoticeContent(n) &&
        !sessionStorage.getItem(u_id)
      ) {
        this.$refs.Notice.open(n, () => {
          sessionStorage.setItem(u_id, "1");
        });

      }
    },
    //上传
    UploadChange(e, t) {
      const _t = this;
      if (t == "chugao") {
        this.thesis.thesisDegreeUrl = e.fullpath;
        this.thesis.attSize = e.fileSize;
        this.thesis.thesisDegreeSize = e.fileShowSize;
        this.thesis.thesisDegreeFileName = e.filename;
      } else if (t == "chongchuan") {
        if (this.thesis.thesisAttUrl) {
          this.thesis.thesisAttUrl.push(e.fullpath)
          this.thesis.thesisDegreeAttSize.push(e.fileShowSize)
          this.thesis.thesisAttFileName.push(e.filename)
        } else {
          this.thesis.thesisAttUrl = [e.fullpath]
          this.thesis.thesisDegreeAttSize = [e.fileShowSize]
          this.thesis.thesisAttFileName = [e.filename]
        }
      } else if (t == "process") {
        this.thesis.processMaterialsUrl = e.fullpath;
        this.thesis.processSize = e.fileSize;
        this.thesis.processShowSize = e.fileShowSize;
        this.thesis.processFileName = e.filename;
      }
      this.$forceUpdate()
    },
    beforeUpload(t) {
      if (t == "chugao") {
        // if (!this.thesis.thesisDegreeName) {
        //   this.$message({
        //     showClose: true,
        //     message: "请先填写论文标题。",
        //     type: "error",
        //   });
        //   return;
        // }

        document
          .getElementById("btn_upload_" + t)
          .getElementsByClassName("el-upload__input")[0]
          .click();
      }
      if (t == "chongchuan") {
        // if (!this.thesis.thesisDegreeName) {
        //   this.$message({
        //     showClose: true,
        //     message: "请先填写论文标题。",
        //     type: "error",
        //   });
        //   return;
        // }

        document
          .getElementById("btn_upload_" + t)
          .getElementsByClassName("el-upload__input")[0]
          .click();
      }
      if (t == "process") {
        // if (!this.thesis.thesisDegreeName) {
        //   this.$message({
        //     showClose: true,
        //     message: "请先填写论文标题。",
        //     type: "error",
        //   });
        //   return;
        // }

        document
          .getElementById("btn_upload_" + t)
          .getElementsByClassName("el-upload__input")[0]
          .click();
      }
    },
    delthesisAtt(i) {
      this.thesis.thesisAttUrl.splice(i, 1)
      this.thesis.thesisDegreeAttSize.splice(i, 1)
      this.thesis.thesisAttFileName.splice(i, 1)
      this.$forceUpdate()
    },
    // submitToAuditb() {
    //   const params = {
    //     thesisId: this.thesis.id,
    //     name: this.thesis.name,
    //     email: this.thesis.email,
    //     attPath: this.submitToAudit.attPath,
    //     attSize: this.submitToAudit.attSize,
    //     remark: this.submitToAudit.remark,
    //   };
    //   if (!params.attPath) {
    //     this.$message({
    //       showClose: true,
    //       message: "请先上传最新版论文后再操作！",
    //       type: "error",
    //     });
    //     return;
    //   }
    //   const _t = this;
    //   _t.$http.post("/student/thesis2/submitToAudit", params).then(res => {
    //     if (res) {
    //       this.$message({
    //         showClose: true,
    //         message: "提交成功，等待指导老师审核。",
    //         type: "success",
    //       });
    //       _t.getInfo();
    //     }
    //   });

    // },

    toSubmit() {
      const _t = this,
        thesis = this.thesis;
      // if (!thesis.thesisDegreeName) {
      //   this.$message({
      //     showClose: true,
      //     message: "请先填写论文标题。",
      //     type: "error",
      //   });
      //   return;
      // }
      if (!thesis.thesisDegreeUrl) {
        this.$message({
          showClose: true,
          message: "请先上传论文后再操作！",
          type: "error",
        });
        return;
      }
      if (!thesis.thesisAttUrl || !thesis.thesisAttUrl.length) {
        this.$message({
          showClose: true,
          message: "请先上传查重报告后再操作！",
          type: "error",
        });
        return;
      }

      const params = {
        thesisDegreeBatchId: _t.config.id,
        thesisDegreeName: _t.thesis.thesisDegreeName,
        thesisDegreeUrl: _t.thesis.thesisDegreeUrl,
        thesisDegreeFileName: _t.thesis.thesisDegreeFileName,
        thesisDegreeSize: _t.thesis.thesisDegreeSize,
        thesisAttUrl: _t.thesis.thesisAttUrl,
        thesisAttFileName: _t.thesis.thesisAttFileName,
        thesisDegreeAttSize: _t.thesis.thesisDegreeAttSize,
        thesisDegreeRemark: _t.thesis.thesisDegreeRemark,

        graduationDate: _t.thesis.graduationDate,
        graduationNo: _t.thesis.graduationNo,
        processMaterialsUrl: _t.thesis.processMaterialsUrl,
        processFileName: _t.thesis.processFileName,
        processSize: _t.thesis.processSize,
      };

      this.$confirm("是否确定提交给老师审核吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          _t.$http
            .post("/student/degree/submit", params)
            .then(res => {
              if (res) {
                this.$message({
                  showClose: true,
                  message: "提交成功，等待指导老师审核。",
                  type: "success",
                });
                _t.getInfo();
              }
            });
        })
        .catch(() => { });
    },
    uploadAtt2() { },
    toUploadAtt() {
      this.$confirm("重新上传将会覆盖现有论文，是否继续！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          document
            .getElementById("btn_uploadAtt")
            .getElementsByClassName("el-upload__input")[0]
            .click();
        })
        .catch(() => { });
    },


    handleClick(tab, event) {
      if(this.activeName==2){
        this.degree={}
        this.$http
        .get("/student/degreeApply", { batchId: this.defaultThesisBatchId })
        .then(res => {
          if(res&&res.length>0){
            this.degree = res[0]
          }
        });
      }
      
    },
    degreeSubmit(){
      const _this=this
      if (!this.degree.enrolTime) {
        this.$message({
          showClose: true,
          message: "请先选择入学时间后再操作！",
          type: "error",
        });
        return;
      }
      if (this.config.needIdCard&&!this.degree.idCardA) {
        this.$message({
          showClose: true,
          message: "请先上传身份证正面后再操作！",
          type: "error",
        });
        return;
      }
      if (this.config.needIdCard&&!this.degree.idCardB) {
        this.$message({
          showClose: true,
          message: "请先上传身份证反面后再操作！",
          type: "error",
        });
        return;
      }
      if (this.config.needDiploma&&!this.degree.diploma) {
        this.$message({
          showClose: true,
          message: "请先上传毕业证后再操作！",
          type: "error",
        });
        return;
      }
      if (this.config.needDegree&&!this.degree.degree) {
        this.$message({
          showClose: true,
          message: "请先上传学位证后再操作！",
          type: "error",
        });
        return;
      }
      if (this.config.needSchoolAward&&!this.degree.schoolAward) {
        this.$message({
          showClose: true,
          message: "请先输入在校期间奖励后再操作！",
          type: "error",
        });
        return;
      }
      if (this.config.needSchoolPunish&&!this.degree.schoolPunish) {
        this.$message({
          showClose: true,
          message: "请先输入在校期间处分后再操作！",
          type: "error",
        });
        return;
      }
      this.$http
            .post("/student/degreeApply", {...this.degree,batchId:this.defaultThesisBatchId})
            .then(res => {
              console.log(res);
              
                _this.$message({
                  showClose: true,
                  message: '操作成功',
                  type: "success",
                });
                _this.getInfo();
            });
        
    }
  },
};
</script>

<style scoped lang="scss">
@import "@/variable.scss";
.tm_required {
  color: #f00;
  margin-left: 10px;
}

.editPhone .el-input {
  width: 250px;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.title {
  position: relative;
  padding-left: 8px;
  margin-bottom: 10px;

  &::before {
    content: "";
    position: absolute;
    width: 3px;
    height: 18px;
    background-color: $primary;
    left: 0;
    top: 2px;
  }
}

.degree-form {
  padding: 1.25rem;
  margin-bottom: 10px;
}

.bg {
  background-color: #f5f5f5;
  margin-bottom: 10px;
  border-radius: 12px;
  padding: 12px;

  .el-form-item {
    margin-bottom: 12 px;
  }
}


</style>
